<app-dashboard-option [categories]="['CELLS']" [label]="'DEPTH'">
  <div app-dashboard-option-content>
    <button *ngFor="let depth of depths" mdbBtn (click)="onValue(depth)" type="button" color="light" size="sm" class="px-2 z-depth-0 my-0 ml-1 mr-0 app-dashboard-layout-depth-button" mdbWavesEffect>
      <span class="{{ depth == dashboardLayout.depth ? color : 'blue-grey' }}-text font-weigth-bold">{{depth}}</span>
    </button>
  </div>
</app-dashboard-option>